import { Component, OnInit, Input } from '@angular/core';
import { Pagination } from '../../core/models/pagination.model';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';

@Component({
  selector: 'app-lot-verication-batch-table',
  templateUrl: './lot-verication-batch-table.component.html',
  styleUrls: ['./lot-verication-batch-table.component.css']
})
export class LotVericationBatchTableComponent implements OnInit {

  @Input() pagination: Pagination;

  @Input() passed_id: any;

  constructor(private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {
  }

  // Load Next Page when using Pagination
  showPage(page: string) {
    
    let currentParam = {
      w_page: 1,
      b_page: 1,
    };

    this.route.queryParams.subscribe(params => {
      Object.keys(params).forEach(key => {
          if (params[key] !== '') {
              currentParam[key] = params[key];
          }
      });
    });

    const navigationExtras: NavigationExtras = {
      queryParams: {
          w_page: this.passed_id === 'white' ? page : currentParam.w_page,
          b_page: this.passed_id === 'blue' ? page : currentParam.b_page,
      },
      queryParamsHandling: 'merge'
    };

    // Get the current path
    const currentUrlPath = this.router.url.split('?')[0];

    this.router.navigate([currentUrlPath], navigationExtras);
  }


}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/lot/lot-verication-batch-table/lot-verication-batch-table.component.ts